import React from 'react';
import AdminLayout from '../../../../Components/CommonComponents/Layout/adminLayout';
import CouponCodeFormContainer from '../../../../Containers/AdminContainer/CouponCodes/CouponCodesForm';
const CouponCodesFormScreen = () => {
  return <CouponCodeFormContainer />;
};

export default CouponCodesFormScreen;
